import {
  Dialog, DialogFooter, DialogType, mergeStyleSets, PrimaryButton, Text,
} from '@fluentui/react';
import React from 'react';
import Store from '../../shared/state/Store';
import UiReducer from '../../shared/state/UiReducer';
import Theme from '../../shared/Theme';
import ModellerDefaults from '../ModellerDefaults';

const componentStyles = mergeStyleSets({
  tableWrapper: {
    maxHeight: '70vh',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    selectors: {
      thead: {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: 'white',
      },
    },
  },
});

export default () => {
  const [globalState, dispatch] = Store.useStore();

  const dialogData = UiReducer.getGenericUiAttribute(globalState, ModellerDefaults.ComponentKeys.ModellerNodeVariablesViewKey);

  const hide = () => {
    dispatch(UiReducer.setGenericUiAttribute(ModellerDefaults.ComponentKeys.ModellerNodeVariablesViewKey, undefined));
  };

  if (!dialogData) {
    return <></>;
  }

  const { nodeData, networkName, nodeName } = dialogData;
  const variables = nodeData?.variables || [];

  return (
    <div style={{
      position: 'fixed',
      left: '-9999px',
      width: '0px',
      height: '0px',
    }}
    >
      <Dialog
        hidden={false}
        onDismiss={hide}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Node Variables',
        }}
        modalProps={{
          isBlocking: false,
        }}
        styles={{
          main: {
            maxWidth: '750px !important',
          },
        }}
      >
        <Text block style={{ marginBottom: '10px' }}>
          {`Node: ${nodeName || 'N/A'}`}
        </Text>
        <Text block style={{ marginBottom: '10px' }}>
          {`Network: ${networkName || 'N/A'}`}
        </Text>

        {variables.length === 0 ? (
          <Text block style={{ padding: '10px', color: '#605e5c' }}>No variables defined</Text>
        ) : (
          <div className={componentStyles.tableWrapper}>
            <table
              className={[Theme.styles.table,
                Theme.styles.tableNoPadding,
                Theme.styles.tableText,
                Theme.styles.tableRowHighlight,
              ].join(' ')}
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Default Value</th>
                </tr>
              </thead>
              <tbody>
                {variables.map((variable) => (
                  <tr key={variable.name}>
                    <td>{variable.name || 'N/A'}</td>
                    <td>{variable.value !== undefined && variable.value !== null ? String(variable.value) : 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <DialogFooter>
          <PrimaryButton onClick={hide} text="Close" />
        </DialogFooter>
      </Dialog>
    </div>
  );
};
